import React, { useState } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import "./log-incident.css"
import LogIncidentForm from './log-Incident-form'
import LogIncidentList from './log-Incident-list'

export default function LogIncident(props) {
  const [selectedIndex, setSelectedIndex] = useState(0);
   const [updateDate, setUpdateDate] = useState(null);
    const handleSelect = (index) => {
      console.log(`Selected Tab: ${index}`);
      setSelectedIndex(index);
    };
  return <React.Fragment>
    <Tabs selectedIndex={selectedIndex} onSelect={handleSelect}>


      <TabList>
        <Tab >Log Incident List</Tab>
        <Tab >Log Incident Form</Tab>
      </TabList>
      <div className='row'>
      <TabPanel>
          <LogIncidentList setSelectedIndex={setSelectedIndex} setUpdateDate={setUpdateDate} />
        </TabPanel>
        <TabPanel>
          <LogIncidentForm data={props?.data} setSelectedIndex={setSelectedIndex} updateDate={updateDate} />
        </TabPanel>
        

      </div>
    </Tabs>
  </React.Fragment>
}
